import { Dispatch, SetStateAction, useState } from 'react';
import { Label } from 'components/Input/Input';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import countries from '../../lib/countries';
import { colors } from 'styles';

const animatedComponents = makeAnimated();

const customStyles = {
  control: (provided: any) => ({
    ...provided,
    padding: '6px 4px',
    margin: '10px 0 15px 0',
    borderRadius: '16px',
    background: `radial-gradient(
      158.48% 294.91% at 50% 320.96%,
      rgba(255, 0, 122, 0.2) 0%,
      rgba(255, 0, 122, 0) 100%
    ),
    linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1))`,
    fontSize: '16px',
    boxShadow: '0px 70.82px 130.86px 0px rgba(0, 0, 0, 0.1)',
    border: `1px solid ${colors.gray}4c`,
    '&:hover': { borderColor: '#E6E6E64c' },
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: colors.white,
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: colors.white, // Ensure selected option text is white
  }),
};

interface OptionType {
  value: string;
  label: string;
}

const options: OptionType[] = countries.map((country) => ({
  value: country.code,
  label: `${country.name}`,
}));

interface CountryDropdownProps {
  label?: boolean;
  country: OptionType | null;
  setCountry: Dispatch<SetStateAction<OptionType | any>>;
}

export const CountryDropdown = ({
  country,
  setCountry,
  label,
}: CountryDropdownProps) => {
  return (
    <div>
      {label && <Label>Country</Label>}
      <Select
        options={options}
        components={animatedComponents}
        placeholder='Select Country'
        styles={customStyles}
        isSearchable
        value={country}
        onChange={setCountry}
      />
    </div>
  );
};
